import React from 'react';
import { useRouteMatch, Switch, Redirect } from 'react-router-dom';

import AuthorizedRoute from 'routes/AuthorizedRoute';
import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';

import ListWallet from './submodules/list/List';
import CreateWallet from './submodules/create';

const WalletDashboard: React.FC<{}> = () => {
	const { path } = useRouteMatch();

	return (
		<Switch>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.wallet}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.wallet].getCsvDetails]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/list`}
				component={ListWallet}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.wallet}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.wallet].addCsvDetails]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/create`}
				component={CreateWallet}
				exact
			/>
			<Redirect to={`${path}/list`} />
		</Switch>
	);
};

export default WalletDashboard;
